/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Activate Subscription?" |
*
* @param {Activate_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const activate_confirm_title = /** @type {((inputs?: Activate_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer l'abonnement ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement aktivieren?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivare l'abbonamento?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активировать подписку?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Activar suscripción?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活订阅？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションをアクティブ化しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता सक्रिय करें?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar assinatura?")
	return /** @type {LocalizedString} */ ("Activate Subscription?")
});